import classNames from 'classnames';

import freeTravelLogo from '@/assets/free-travel-white.png';

import Characters from './Characters';
import styles from './index.module.scss';
import useCharacterAnimation from './use-character-animation';
import useFormSignals from './use-form-signals';

type Props = {
  readonly className?: string;
};

const CartoonPanel = ({ className }: Props) => {
  const { isTyping, passwordLength, showPassword } = useFormSignals();
  const hasPassword = passwordLength > 0;
  const animationState = useCharacterAnimation({ isTyping, hasPassword, showPassword });

  return (
    <div className={classNames(styles.panel, className)}>
      <div className={styles.brand}>
        <img className={styles.brandLogo} src={freeTravelLogo} alt="FreeTravel" />
        <span className={styles.badge}>PARTNERS</span>
      </div>

      <Characters {...animationState} />

      <div className={styles.footer}>
        © 2026 FreeTravel
        {' · '}
        <a
          className={styles.footerLink}
          href="https://agent.freetravel.me/agreement"
          target="_blank"
          rel="noopener noreferrer"
        >
          Affiliate Agreement
        </a>
        {' · '}
        <a
          className={styles.footerLink}
          href="https://agent.freetravel.me/privacy"
          target="_blank"
          rel="noopener noreferrer"
        >
          Privacy Policy
        </a>
        {' · Trusted by 9,200+ agencies worldwide'}
      </div>

      {/* Decorative blobs */}
      <div className={styles.blobTop} />
      <div className={styles.blobBottom} />
    </div>
  );
};

export default CartoonPanel;
